import axiosClient from './axiosClient';

const vendorStaffService = {
    getStaff: async (params) => {
        const response = await axiosClient.get('/vendor/staffs', { params });
        return response.data;
    },
    createStaff: async (payload) => {
        const response = await axiosClient.post('/vendor/staffs/new', payload);
        return response.data;
    },
    updateStaff: async (id, payload) => {
        const response = await axiosClient.patch(`/vendor/staffs/${id}`, payload);
        return response.data;
    },
    deleteStaff: async (id) => {
        const response = await axiosClient.delete(`/vendor/staffs/${id}`);
        return response.data;
    }
};

export default vendorStaffService;
